// tslint:disable
export var ExtauthValidateStatus;
(function (ExtauthValidateStatus) {
    // Password is valid
    ExtauthValidateStatus[ExtauthValidateStatus["Valid"] = 0] = "Valid";
    // Username is valid
    ExtauthValidateStatus[ExtauthValidateStatus["UserFound"] = 1] = "UserFound";
    // Password invalid
    ExtauthValidateStatus[ExtauthValidateStatus["Invalid"] = 2] = "Invalid";
    // Username not found
    ExtauthValidateStatus[ExtauthValidateStatus["UserNotFound"] = 3] = "UserNotFound";
    // Account is disabled
    ExtauthValidateStatus[ExtauthValidateStatus["AccountDisabled"] = 4] = "AccountDisabled";
    // Account is locked
    ExtauthValidateStatus[ExtauthValidateStatus["AccountLocked"] = 5] = "AccountLocked";
    // Password has expired
    ExtauthValidateStatus[ExtauthValidateStatus["PasswordExpired"] = 6] = "PasswordExpired";
    // An unexpected server error has occurred
    ExtauthValidateStatus[ExtauthValidateStatus["ServerError"] = 7] = "ServerError";
})(ExtauthValidateStatus || (ExtauthValidateStatus = {}));
ExtauthValidateStatus['VALID'] = 0;
ExtauthValidateStatus['USERFOUND'] = 1;
ExtauthValidateStatus['INVALID'] = 2;
ExtauthValidateStatus['USERNOTFOUND'] = 3;
ExtauthValidateStatus['ACCOUNTDISABLED'] = 4;
ExtauthValidateStatus['ACCOUNTLOCKED'] = 5;
ExtauthValidateStatus['PASSWORDEXPIRED'] = 6;
ExtauthValidateStatus['SERVERERROR'] = 7;
//# sourceMappingURL=ExtauthValidateStatus.js.map